// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-link {
    display: block;
    text-align: center;
    margin-top: 25px;
}
.question{
color: var(--typography-default-headers-Charcoal, #403C3C);
text-align: center;
font-family: "Mecherle Sans";
font-size: 22px;
font-style: normal;
font-weight: 600;
line-height: 32px;
margin-bottom: 32px; 
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/incident-details/airbags/airbags.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;AACA,0DAA0D;AAC1D,kBAAkB;AAClB,4BAA4B;AAC5B,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB,mBAAmB;AACnB","sourcesContent":[".lr-link {\n    display: block;\n    text-align: center;\n    margin-top: 25px;\n}\n.question{\ncolor: var(--typography-default-headers-Charcoal, #403C3C);\ntext-align: center;\nfont-family: \"Mecherle Sans\";\nfont-size: 22px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 32px;\nmargin-bottom: 32px; \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
